import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useBranding } from '../contexts/BrandingContext';

/**
 * Per-user dark/light mode toggle.
 *
 * Stores the preference in localStorage so each user can choose their own
 * theme without flipping the company-wide branding for everybody. Reads /
 * writes through BrandingContext so the change applies instantly across
 * the whole app.
 */
export const ThemeToggle = ({ className = '', size = 'md' }) => {
  const { theme, setTheme } = useBranding();
  const isDark = theme === 'dark';
  const sizeCls = size === 'sm' ? 'w-8 h-8' : 'w-9 h-9';
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      data-theme={isDark ? 'dark' : 'light'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className={
        `${sizeCls} flex items-center justify-center rounded-md border border-slate-200 ` +
        'bg-white text-slate-700 hover:bg-slate-50 hover:text-slate-900 ' +
        'transition-colors shadow-sm ' + className
      }
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};

export default ThemeToggle;
